import React from 'react';
import { Grid, Placeholder, Segment } from 'semantic-ui-react';

function BookingLoader(props) {
    return (
        <Grid className="mt-4" columns="equal">
            <Grid.Column computer={16}>
              <Segment raised>
                <Placeholder fluid>
                  <Placeholder.Header>
                    <Placeholder.Line length="full" />
                    <Placeholder.Line />
                  </Placeholder.Header>
                </Placeholder>
              </Segment>
            </Grid.Column>
            <Grid.Column computer={16}>
              <Segment raised>
                <Placeholder fluid>
                  <Placeholder.Header>
                    <Placeholder.Line length="full" />
                    <Placeholder.Line />
                    <Placeholder.Line length="full" />
                  </Placeholder.Header>
                </Placeholder>
              </Segment>
            </Grid.Column>
        </Grid>
    )
}

export default BookingLoader;